import { Component, OnInit } from '@angular/core';
import {FormControl} from '@angular/forms';
import {BaseComponent, Shared, UserService} from '@rubii/frontend-common';
import {User} from '@rubii/frontend-common/lib/models/account/User';

@Component({
  selector: 'app-advertiser',
  templateUrl: './advertiser.component.html',
  styleUrls: ['./advertiser.component.scss']
})
export class AdvertiserComponent extends BaseComponent implements OnInit {

  shared: Shared;
  user: User;

  constructor(private userService: UserService) {
    super();
    this.user = userService.user;
  }

  ngOnInit() {

  }

}
